.surface { height: 100%; background: var(--color-surface); border-radius: var(--radius-lg) 0 0 0; border-top: 1px solid var(--color-border); border-left: 1px solid var(--color-border); }
@media (max-width: 899px) { .surface { border-radius: 0; border-left: 0; } }
